export enum MonthYearRecurrence {
  MonthDay = 1,
  DayOfWeek = 2,
  LastDayOfWeek = 3
}
